<template>
  <vs-popup :title="$t('EditRecipientInfo')" :active.sync="showModal">
    <form v-if="show">
      <div class="vx-row">
        <div class="vx-col lg:w-1/2 sm:w-1/2 w-full">
          <vs-input
            class="inputx mb-2 mt-1"
            v-model="model.fullName"
            name="fullName"
            :label="$t('FullName')"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('fullName')">{{
            errors.first("fullName")
          }}</span>
        </div>
        <div class="vx-col lg:w-1/2 sm:w-1/2 w-full">
          <vs-input
            class="inputx mb-2 mt-1"
            v-model="model.phoneNumber"
            name="phoneNumber"
            :label="$t('PhoneNumber')"
            v-validate="{ regex: '^([0-9]+)$', required: 'true' }"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('phoneNumber')"
            >{{ errors.first("phoneNumber") }}</span
          >
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col lg:w-1/2 sm:w-1/2 w-full">
          <label class="vs-select--label">{{ $t("Province") }}</label>
          <v-select
            label="name"
            :options="allProvinces"
            name="province"
            :reduce="x => ({ provinceId: x.id, provinceName: x.name })"
            ref="provinceListSelect"
            :value="
              allProvinces.filter(x => x.id == model.addressInfo.province.id)[0]
                .name
            "
            @input="selectProvince"
            :clearable="false"
            dir="rtl"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('province')">{{
            errors.first("province")
          }}</span>
        </div>
        <div class="vx-col lg:w-1/2 sm:w-1/2 w-full" v-if="showCity">
          <label class="vs-select--label">{{ $t("City") }}</label>
          <v-select
            label="name"
            name="city"
            :options="allCities"
            :reduce="x => ({ cityId: x.id, cityName: x.name })"
            v-validate="{ required: true }"
            :clearable="true"
            ref="cityListSelect"
            :value="
              model.addressInfo.province.cityId
                ? allCities.filter(
                    x => x.id == model.addressInfo.province.cityId
                  )[0].name
                : ''
            "
            @input="selectCity"
            :disabled="cityDisable"
            dir="rtl"
          >
          </v-select>
          <span class="text-danger text-sm" v-show="errors.has('city')">{{
            errors.first("city")
          }}</span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col lg:w-1/2 sm:w-1/2 w-full">
          <vs-input
            class="inputx mb-2 mt-1"
            v-model="model.addressInfo.postalCode"
            name="postalCode"
            :label="$t('PostalCode')"
            v-validate="{ regex: '^([0-9]+)$', required: 'true', digits: '10' }"
          />
          <span class="text-danger text-sm" v-show="errors.has('postalCode')">{{
            errors.first("postalCode")
          }}</span>
        </div>
        <div class="vx-col lg:w-1/2 sm:w-1/2 w-full">
          <vs-input
            class="inputx mb-2 mt-1"
            v-model="model.mobileNumber"
            name="mobileNumber"
            :label="$t('MobileNumber')"
            v-validate="{ regex: '^([0-9]+)$', required: 'true' }"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('mobileNumber')"
            >{{ errors.first("mobileNumber") }}</span
          >
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-textarea
            class="inputx mb-2"
            v-model="model.addressInfo.address"
            name="address"
            :label="$t('Address')"
            v-validate="'required'"
          />
          <span class="text-danger text-sm" v-show="errors.has('address')">{{
            errors.first("address")
          }}</span>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button
            type="filled"
            class="float-right mt-2"
            @click.prevent="submitForm"
            :disabled="disabled"
            >{{ $t("Save") }}</vs-button
          >
        </div>
      </div>
    </form>
  </vs-popup>
</template>
<style lang="scss">
.vs-con-textarea h4 {
  margin-bottom: 0.25rem !important;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "vue-select";
const dict = {
  custom: {
    fullName: {
      required: "لطفا نام و نام خانوادگی تحویل گیرنده را وارد نمایید."
    },
    phoneNumber: {
      required: "لطفا شماره تلفن تحویل گیرنده را وارد نمایید.",
      regex: "شماره تلفن نامعتبر می باشد"
    },
    city: {
      required: "لطفا شهر تحویل گیرنده را وارد نمایید."
    },
    postalCode: {
      required: "لطفا کدپستی تحویل گیرنده را وارد نمایید.",
      regex: "کدپستی نامعتبر می باشد",
      digits: "لطفا کدپستی تحویل گیرنده را وارد نمایید."
    },
    address: {
      required: "لطفا آدرس تحویل گیرنده را وارد نمایید."
    }
  }
};
Validator.localize("fa", dict);
export default {
  props: {
    show: { default: false },
    model: {
      type: Object
    },
    ownerUserId: {
      type: Number
    }
  },
  data() {
    return {
      city: "",
      disabled: false,
      showCity: false,
      cityDisable: true,
      modelInfo: {}
    };
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    },
    ...mapGetters({
      allProvinces: "country/provinceList",
      allCities: "country/cityList"
    })
  },
  methods: {
    ...mapActions({
      fetchCitiesById: "country/fetchCitiesById",
      editRecipientInfo: "recipientsShipping/update"
    }),
    selectProvince(province) {
      this.cityDisable = true;
      this.model.addressInfo.province.id = province.provinceId;
      this.model.addressInfo.province.name = province.provinceName;
      this.model.addressInfo.province.cityId = "";
      this.model.addressInfo.province.cityName = "";
      this.fetchCitiesById(province.provinceId).then(() => {
        this.cityDisable = false;
      });
      if (this.$refs.cityListSelect) {
        this.$refs.cityListSelect.clearSelection();
      }
      if (this.model.addressInfo.province.cityId) {
        this.model.addressInfo.province.cityId = "";
        this.model.addressInfo.province.cityName = "";
      }
    },
    selectCity(city) {
      if (city) {
        this.model.addressInfo.province.cityId = city.cityId;
        this.model.addressInfo.province.cityName = city.cityName;
      }
    },
    submitForm() {
      this.modelInfo.recipient = JSON.parse(JSON.stringify(this.model));
      this.modelInfo.ownerUserId = JSON.parse(JSON.stringify(this.ownerUserId));
      this.$validator.validateAll().then(result => {
        if (result) {
          this.disabled = true;
          this.editRecipientInfo(this.modelInfo).then(() => {
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
              showConfirmButton: false,
              timer: 2000
            });
            this.$emit("finish");
            this.model = {};
            this.$validator.reset();
            this.disabled = false;
          });
        } else {
          this.$swal({
            position: "center-center",
            type: "warning",
            text: "خطای سیستمی !",
            showConfirmButton: false,
            timer: 2000
          });
        }
      });
    }
  },
  watch: {
    show() {
      if (this.show) {
        this.fetchCitiesById(this.model.addressInfo.province.id).then(() => {
          this.showCity = true;
          this.cityDisable = false;
        });
      } else {
        this.cityDisable = true;
        this.showCity = false;
      }
      this.$validator.reset();
    }
  },
  components: {
    "v-select": vSelect
  }
};
</script>
